import React, { createContext, useContext, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { currentModelEntityVersionSelector } from 'Redux/monitoringModelEntityModule/selectors';
import { LocalStorageKeys } from 'Utils/localStorage';
// --- Version preselect persist
const setStoredVersionId = (id) => {
    localStorage.setItem(LocalStorageKeys.PRESELECTED_VERSION_ID, String(id));
};
const getStoredVersionId = () => parseInt(localStorage.getItem(LocalStorageKeys.PRESELECTED_VERSION_ID));
const getInitialVersionId = () => {
    const versionId = getStoredVersionId();
    if (Number.isNaN(versionId))
        return null;
    return versionId;
};
// Context
const PreselectedVersionIdContext = createContext(null);
// Provider Component
const ModelEntityPreselectedVersionIdProvider = ({ children }) => {
    const currentVersion = useSelector(currentModelEntityVersionSelector);
    const [currentPreselectedVersionId, setCurrentPreselectedVersionId] = useState(getInitialVersionId());
    // Preselect Version clear on current version set
    useEffect(() => {
        if (!currentVersion)
            return;
        setStoredVersionId(null);
        setCurrentPreselectedVersionId(null);
    }, [currentVersion]);
    // Handlers
    const setPreselectedVersionId = (versionId) => {
        setStoredVersionId(versionId);
        setCurrentPreselectedVersionId(versionId);
    };
    // Render
    return (React.createElement(PreselectedVersionIdContext.Provider, { value: {
            preselectedVersionId: currentPreselectedVersionId,
            setPreselectedVersionId
        } }, children));
};
// Custom Hook
export const useModelEntityPreselectedVersionId = () => useContext(PreselectedVersionIdContext);
export default ModelEntityPreselectedVersionIdProvider;
